var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.proposal)?_c('div',{staticClass:"tenant-info-wrapper"},[(_vm.isProposalValid)?_c('TenantValid',{staticClass:"tenant-info-box",attrs:{"proposal":_vm.proposal}}):_c('TenantExpired',{staticClass:"tenant-info-box"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }